module.exports = __webpack_public_path__ + "img/video_icon05.7718e3e0.png";